import type { Tutorial } from '../types'

const IMG = '/images/tutorials/mobile/coach-copilot'

export const coachCopilotTutorial: Tutorial = {
  slug: 'coach-copilot',
  title: 'Coach Co-Pilot for Partners',
  subtitle: 'A briefing so you know what to say — you write the words',
  date: '2026-07-09',
  category: 'Sharing & Support',
  platform: 'mobile',
  tags: ['Goals Partners', 'Wellness Coach', 'comment', 'coach brief'],
  description:
    'When someone becomes a Goals Partner, the Wellness Coach summarizes how the goal owner is doing from real check-in history — so the partner can leave thoughtful comments in their own words.',
  highlights: [
    'Coach brief summarizes how the goal owner is doing from real check-in history.',
    'Leave a comment opens a blank composer — partners write their own encouragement.',
    'Suggest a Coach hands off deeper AI support when that fits the moment.',
  ],
  coverImage: `${IMG}/01_coach_brief_and_draft_button.png`,
  sections: [
    {
      heading: 'The brief: know what\'s going on before you say anything',
      paragraphs: [
        'Open a partnership and the first thing you see is the Coach\'s take on how the goal owner is doing — pulled straight from their goal activity, no digging required. Tap the refresh icon any time to have the Coach look again.',
      ],
      quote:
        'You are currently working on establishing a meditation habit, with a recent streak of one day. How to help: send a daily reminder to meditate; celebrate small wins to reinforce the habit.',
      image: {
        src: `${IMG}/01_coach_brief_and_draft_button.png`,
        alt: 'Coach brief on partnership screen',
        caption: 'Coach brief',
      },
    },
    {
      heading: 'Leave a comment: your words, not a draft',
      paragraphs: [
        'Reactions are great for a quick "I see you," but sometimes a partner wants to say something real. They tap **Leave a comment** — a blank composer opens so they write what they actually mean to say, often informed by the brief they just read.',
      ],
      quote:
        'Hey! Just wanted to check in and see how your meditation practice is going. You\'ve got a great start with your streak—keep it up! Remember, even a few minutes each day can make a big difference.',
      image: {
        src: `${IMG}/02_draft_inserted_in_composer.png`,
        alt: 'Partner comment composer on partnership screen',
        caption: 'Leave a comment composer',
      },
    },
    {
      heading: 'The send: it\'s the partner\'s message, always',
      paragraphs: [
        'Edit the message, then tap send. It posts exactly like any other message in the shared feed — timestamped, attributed to the partner, visible to the client.',
      ],
      image: {
        src: `${IMG}/03_edited_nudge_sent.png`,
        alt: 'Partner comment sent in partnership feed',
        caption: 'Comment sent',
      },
    },
  ],
  whyMatters:
    'Most accountability apps hand a partner a follow button and hope for the best. Livewello gives them a briefing grounded in real check-in history, then lets them respond as a person. Coach Suggest covers AI support when that\'s what the moment needs; comments stay human.',
  nextSlug: 'collaborator-messaging',
  relatedSlugs: ['accountability-partners', 'collaborator-messaging'],
  meta: {
    description:
      'Coach Co-Pilot for Goals Partners: AI briefings from real check-in history so supporters know what to say before they leave a comment.',
    ogImage: `${IMG}/01_coach_brief_and_draft_button.png`,
  },
}
